import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layout",
  "use": "icon-layout-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-layout\">\r\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\r\n<g><path d=\"M10,10v980h980V10H10z M323.6,950.8H49.2V49.2h274.4V950.8z M950.8,950.8h-588V519.6h588V950.8z M950.8,480.4h-588V49.2h588V480.4z\" /></g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol